import { useEffect, useState } from "react";

/**
 * Real parallax hook using requestAnimationFrame for smooth GPU-accelerated transforms
 * @param speed - Parallax speed multiplier (positive = moves right, negative = moves left)
 * @returns Current parallax offset in pixels
 */
export function useParallax(speed: number): number {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (speed === 0) {
      setOffset(0);
      return;
    }

    let rafId: number;
    let ticking = false;

    const updateParallax = () => {
      const scrollY = window.scrollY;
      const newOffset = scrollY * speed;
      setOffset(newOffset);
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        rafId = requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial update

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [speed]);

  return offset;
}

